import React from 'react';
import classNames from 'classnames/bind';
import styles from './ScoreLine.module.scss';

const cx = classNames.bind(styles);

interface ScoreLineProps {
  steps: string[];
  activeStep: string;
  title: string;
}

const ScoreLine = ({ steps, activeStep, title }: ScoreLineProps): React.ReactElement => {
  const fields: JSX.Element[] = steps.map((step) => (
    <div key={step} className={cx('step', { active: step === activeStep })} />
  ));

  return (
    <div className={cx('body')} data-testid="score-line">
      <div className={cx('title')}>{title}</div>
      <div className={cx('bar')} />
      <div className={cx('steps')}>{fields}</div>
      <div className={cx('step-label')}>{activeStep}</div>
    </div>
  );
};

export default ScoreLine;
